<template>
  <div class="HospitalListBox">
    <div v-if="Dev">开发中......</div>
    <div v-else class="HospitalList">
      <div class="TopBottomCom FormSelect">
        <FromComm :FromArr="FromArr" @Province="Province" @City="City"></FromComm>
        <div class="CommonBtngroup">
          <CommonBtngroup ref="Btngroup" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
        </div>
      </div>
      <div class="TopBottomCom TableOrBtn">
        <div style="">
          <Commonbtn backgroundColor="#F9FAFC" title="导出" fontSize="14px" @btnclick="Export" :src="require('@/assets/channel/export.png')">
          </Commonbtn>
        </div>
        <div class="Table">
          <Commontable ref="refTableHospital" :loadingTable="loadingTableContract" @onRowClick="onRowClick" width="918px" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
          </Commontable>
          <div class="pagination">
            <Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :pageSize="pageSize" :total="total"></Pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FromComm from '../../components/fromComponents/Commfrom/from-comm.vue'
import CommonBtngroup from '@/components/commongroup.vue'
import Commontable from '@/components/common-table.vue'
import Pagination from '@/components/pagination.vue'
import headerData from './headerData/headerData'
import FromArr from './FromData/FromArr'
import Commonbtn from '@/components/common-btn.vue'
import DialogFrom from '@/components/dialog-from.vue'
import CommonbtnUpLoad from '@/components/common-upload.vue'
import FilesAndPictures from '@/components/FilesAndPictures.vue'
import Picturepreview from '@/components/picturepreview.vue'
import Dialog from '@/components/dialog.vue'
import utils from '@/common/utils'
import {
  GetProvince,
  GetCity,
  GetDistrict,
  HosProcessList,
  HosProcessExport
} from '@/api/home'
export default {
  components: {
    CommonBtngroup,
    Commontable,
    Pagination,
    Commonbtn,
    DialogFrom,
    CommonbtnUpLoad,
    FilesAndPictures,
    Picturepreview,
    Dialog,
    FromComm
  },
  props: {},
  data() {
    return {
      Dev: false,
      loadingTableContract: false,
      rowData: null,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      headerData: [],
      tableData: [],
      FromArr: []
    }
  },
  created() {
  },
  mounted() {
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.FromArr = JSON.parse(JSON.stringify(FromArr))
    this.GetProvince()
    this.HospitalList()
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async HospitalList() {
      let {
        code,
        data,
        message
      } = await HosProcessList({
        HPCode: this.FromArr[0].modelvalue,
        HPName: this.FromArr[1].modelvalue,
        ProvinceID: this.FromArr[2].modelvalue,
        CityID: this.FromArr[3].modelvalue,
        DistrictID: this.FromArr[4].modelvalue,
        IsTerminalHPOnly: 1,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tableData = data.data
      } else {
        this.$message.warning(message)
      }
    },
    // 导出
    async HospitalExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let resexprot = await HosProcessExport({
        HPCode: this.FromArr[0].modelvalue,
        HPName: this.FromArr[1].modelvalue,
        ProvinceID: this.FromArr[2].modelvalue,
        CityID: this.FromArr[3].modelvalue,
        DistrictID: this.FromArr[4].modelvalue,
        IsTerminalHPOnly: 1,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      })
      if (resexprot) {
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `医院列表导出${str}`, "xlsx")
        loading.close();
      } else {
        // 返回json
        this.$message.warning('导出失败');
        loading.close();
      }
      loading.close()
    },
    Export() {
      this.HospitalExport()
    },
    // 省
    async GetProvince() {
      let {
        data,
        code,
        message
      } = await GetProvince({
      })
      if (code == 0) {
        this.FromArr[2].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.FromArr[2].options.push(obj)
        })
      } else {
        this.$message({
          type: 'error',
          message: "省份列表加载失败"
        })
      }
    },
    // 市
    async getcity(provinceid) {
      this.FromArr[3].modelvalue = ''
      this.FromArr[4].modelvalue = ''
      let params = {
        ProvinceID: provinceid
      }
      let {
        code,
        data
      } = await GetCity({
        params
      })
      if (code == 0) {
        this.FromArr[3].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.FromArr[3].options.push(obj)
        })
      }
    },
    // 区
    async getDistrict(cityID) {
      let params = {
        CityID: cityID
      }
      let {
        code,
        data
      } = await GetDistrict({
        params
      })
      if (code == 0) {
        this.FromArr[4].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.FromArr[4].options.push(obj)
        })
      }
    },
    Province(e) {
      this.getcity(e.FromArr[2].modelvalue)
    },
    City(e) {
      this.getDistrict(e.FromArr[3].modelvalue)
    },

    onRowClick(row) {
      this.rowData = row
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.HospitalList()
    },
    handleSizeChange(pageSize) {
      this.pageSize = PageSize
      this.HospitalList()
    },
    select() {
      this.pageIndex = 1
      this.HospitalList()
    },
    reset() {
      this.FromArr.forEach((item, index) => {
        item.modelvalue = ''
      })
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.HospitalListBox {
  width: 100%;
  height: 100%;

  .HospitalList {
    display: grid;
    gap: 32px;
    .TopBottomCom {
      margin: 1px 10px;
      width: 938px;
      box-shadow: 0px 1px 4px 2px #e5e7ea;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;

      .CommonBtngroup {
        margin-right: 23px;
        margin-top: 30px;
      }
    }
    .FormSelect {
      //   height: 198px;
      padding-bottom: 20px;
    }
    .TableOrBtn {
      // height: 198px;

      .Table {
        margin-top: 10px;
      }
    }
  }
}
</style>